<app-global-loading></app-global-loading>
<router-outlet></router-outlet>

<modal-outlet></modal-outlet>

<app-carousel></app-carousel>

<!-- <app-switcher></app-switcher> -->

